import React from 'react';
import './CeoLetter.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { processLink } from '../../shared/processLink';

export interface CeoLetterInputs {
    image?: any;
    title: string;
    textContent: string;
    cta?: {
        uri: string;
        title: string;
    };
}

export const CeoLetter = ({ inputs }: { inputs: CeoLetterInputs }) => {
    const gImage = getImage(
        inputs.image?.relationships.field_media_image?.localFile
    );
    return (
        <section className="paragraph__ceo_letter kite-container">
            <h2 className="typestack-title-3">{inputs.title}</h2>
            <GatsbyImage
                image={gImage}
                alt={inputs.image?.field_media_image.alt}
            />
            <div
                dangerouslySetInnerHTML={{
                    __html: inputs.textContent,
                }}
            ></div>
            {inputs.cta && (
                <p>
                    <a href={processLink(inputs.cta.uri, false)}>
                        {inputs.cta.title}
                    </a>
                </p>
            )}
        </section>
    );
};
